<template>
  <v-chip
    :class="classes"
    dark
  >
    <slot/>
  </v-chip>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      require: true
    }
  },

  computed: {
    classes() {
      return {
        'material-chip' : true,
        [`${this.type}`] : true,
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.material-chip
  width 115px
  height 18px !important
  font-size 11px !important
  font-weight bold
  display inline-block

types = {
  'pb': {
    'background-color': #3E90C6 !important,
    'border-bottom': 1px solid #225f87,
  },
  'gs': {
    'background-color': #49A26E !important,
    'border-bottom': 1px solid #2c5e41,
  },
}

for type, values in types
  .{type}
    background-color values['background-color'];
    border-bottom values['border-bottom'];
</style>
